var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{ref:"field",attrs:{"label":_vm.label,"items":_vm.items,"hint":_vm.hint,"persistent-hint":!!_vm.hint},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})
}
var staticRenderFns = []

export { render, staticRenderFns }